<template>
	<div></div>
</template>

<script>
export default {
	mounted() {
		//scope=snsapi_login&state=b
		let {code,state} = this.$route.query;
		this.wxLogin(code,state)
	},
	methods:{
		wxLogin(code,state){
			this.$api.WxLogin(code,state)
				.then(data=>{
					// console.log(data)
				})
				.catch(error=>{
					console.log(error)
				})
		}
	}
};
</script>

<style></style>
